<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 17:53:28
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-17 14:31:30
 * @FilePath: \zhucai_user\src\pages\member\child\bm.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="my-container">
    <div class="my-title">分销记录</div>
    <div class="my-content">
      <div class="my-search-box">
        <div class="my-search">
          <i class="el-icon-search" @click="getList"></i>
          <input
            type="text"
            @keyup.enter="getList"
            v-model="getListData.Title"
            placeholder="搜索商品名称"
          />
        </div>
        <div class="my-search">
          <i class="el-icon-search" @click="getList"></i>
          <input
            type="text"
            @keyup.enter="getList"
            v-model="getListData.OrdersNo"
            placeholder="搜索订单编号"
          />
        </div>
        <div class="my-dateRange">
          <el-date-picker
            v-model="getListData.StartDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="开始时间"
          >
          </el-date-picker>
          <span class="heng">-</span>
          <el-date-picker
            v-model="getListData.EndDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="结束时间"
          >
          </el-date-picker>
        </div>
        <el-button @click="getList" class="search-btn">搜索</el-button>
      </div>
      <div class="TotalAmount">
        累计金额（元）：<span class="Amount">{{ TotalAmount }}</span>
      </div>
      <el-table
        v-loading="isLoading"
        :data="tableData"
        class="mt10"
      >
        <el-table-column
          prop="OrdersNo"
          label="订单编号"
          align="left"
          min-width="200"
        >
        </el-table-column>
        <el-table-column
          label="商品名称"
          prop="Title"
          min-width="150"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="Price"
          label="价格（元）"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            <span class="price">{{ scope.row.Price }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="Amount"
          label="支付金额（元）"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            <span class="price b600">{{ scope.row.Amount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="PayTime"
          label="支付时间"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="FxAmount"
          label="分销金额（元）"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            <span class="price b600">{{ scope.row.FxAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="BuyerPhone"
          label="购买者"
          width="180"
          align="center"
        >
        </el-table-column>
      </el-table>
      <my-pagination
        :total="total"
        :pageSize="getListData.PageSize"
        v-model="getListData.PageIndex"
      ></my-pagination>
    </div>
  </div>
</template>

<script>
import { GetSalesFxTotalAmount, GetSalesFxList } from "@/api/member";
import myPagination from "@/components/myPagination.vue";
export default {
  components: { myPagination },
  name: "distribution",
  data() {
    return {
      TotalAmount: 0,
      isLoading: true,
      total: 0,
      tableData: [],
      getListData: {
        Title: "",
        OrdersNo: "",
        StartDate: "",
        EndDate: "",
        PageIndex: 1,
        PageSize: 10,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      GetSalesFxTotalAmount().then((res) => {
        this.TotalAmount = res.data.TotalAmount;
      });
      this.isLoading = true;
      const data = this.getListData;
      GetSalesFxList(data).then((res) => {
        this.isLoading = false;
        this.total = res.count;
        this.tableData = res.data;
      });
    },
  },
  watch: {
    "getListData.PageIndex"() {
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.TotalAmount {
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  margin-top: 20px;
}
.price {
  font-weight: bold;
  font-size: 20px;
  color: #333333;
}
.Amount {
  font-weight: bold;
  font-size: 20px;
  color: #e12a14;
}
.width510 {
  ::v-deep .el-dialog {
    width: 510px;
  }
}
.my-search-box {
  position: relative;
  .my-search {
    width: 251px;
  }
}
.el-select {
  ::v-deep .el-input__inner {
    width: 201px;
    height: 47px;
    background: #f6f8fc;
    border-radius: 23px;
    border: 1px solid #e6e6e6;
  }
}
.el-date-editor {
  width: 180px;
  height: 47px;
  ::v-deep .el-input__inner {
    width: 180px;
    height: 47px;
    background: #f6f8fc;
    border-radius: 23px;
    border: 1px solid #e6e6e6;
  }
}
</style>
